import { render, staticRenderFns } from "./WorkflowSection.vue?vue&type=template&id=7243d823&"
import script from "./WorkflowSection.vue?vue&type=script&lang=js&"
export * from "./WorkflowSection.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports